import { createSlice } from "@reduxjs/toolkit";
import { userNormalLogout, supportLogout } from "../actions";

const initialState = {};

export const bulkUploadSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    sendTemplate: (state, actions) => { },
    uploadInBulk: (state, actions) => { }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
})

export const {
  sendTemplate,
  uploadInBulk
} = bulkUploadSlice.actions;
export default bulkUploadSlice.reducer;